import React, { useMemo } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Icon from '../common/Icon';
import { icons } from '../../config/icons';

// Set up localizer
const localizer = momentLocalizer(moment);

const AttendanceCalendar = ({ attendanceData, leaveData }) => {

    // Map data to events
    const events = useMemo(() => {
        let evts = [];
        
        // Process attendance (Timed Events)
        if (attendanceData) {
            attendanceData.forEach(att => {
                if (att.log_date && att.clock_in) {
                    const start = new Date(att.clock_in);
                    // If no clock out, default to 1 hour or current time for visual block
                    let end = att.clock_out ? new Date(att.clock_out) : new Date(start.getTime() + 60 * 60 * 1000); 
                    
                    evts.push({
                        title: att.total_hours ? `Shift (${att.total_hours}h)` : 'Active Shift',
                        start: start,
                        end: end,
                        allDay: false,
                        resource: { type: 'attendance', data: att }
                    });
                }
            });
        }
        
        // Process leaves (All Day Events)
        if (leaveData) {
            leaveData.forEach(leave => {
                // Calendar component needs dates to cover the span
                let start = new Date(leave.start_date);
                start.setHours(0, 0, 0, 0); // Start of day
                let end = new Date(leave.end_date);
                end.setHours(23, 59, 59, 999); // End of day

                evts.push({
                    title: `${leave.leave_type} Leave - ${leave.status}`,
                    start: start,
                    end: end,
                    allDay: true,
                    resource: { type: 'leave', data: leave }
                });
            });
        }
        
        return evts;
    }, [attendanceData, leaveData]);

    const eventStyleGetter = (event, start, end, isSelected) => {
        let backgroundColor = 'var(--bg-color-secondary)';
        let borderLeft = '4px solid var(--border-color)';
        let color = 'var(--text-color)';
        
        if (event.resource?.type === 'attendance') {
            backgroundColor = 'var(--bg-color-secondary)';
            borderLeft = '4px solid var(--success-color)';
            color = 'var(--text-color)';
        } else if (event.resource?.type === 'leave') {
            const leave = event.resource.data;
            const isApp = leave.status === 'Approved';
            const isRej = leave.status === 'Rejected';
            const statusColor = isApp ? '#0ea5e9' : (isRej ? '#ef4444' : '#f59e0b');
            
            backgroundColor = isApp ? 'rgba(14, 165, 233, 0.1)' : (isRej ? 'rgba(239, 68, 68, 0.1)' : 'rgba(245, 158, 11, 0.1)');
            borderLeft = `4px solid ${statusColor}`;
            color = statusColor;
        }

        let style = {
            backgroundColor,
            borderRadius: '4px',
            opacity: 1,
            color,
            border: 'none',
            borderLeft,
            display: 'block',
            padding: '2px 6px',
            fontSize: '12px',
            fontWeight: '500',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        };
        
        return { style };
    };

    return (
        <div className="rbc-custom-container" style={{ height: '600px', backgroundColor: 'var(--input-bg)', borderRadius: '12px', padding: '16px' }}>
                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: '100%' }}
                    views={['month', 'week', 'day']}
                    defaultView="month"
                    eventPropGetter={eventStyleGetter}
                    popup={true}
                    messages={{
                        today: "Today",
                        previous: "Back",
                        next: "Next",
                        month: "Month",
                        week: "Week",
                        day: "Day",
                        agenda: "Agenda",
                    }}
                />
            </div>
    );
};

export default AttendanceCalendar;
